class App.Views.ExceptionTesterView extends Backbone.View
  initialize: ->
    throw new Error("Something bad happened. (no not really: I'm just testing the JS error handling ;))")

